const API_ENDPOINTS = {
    // Authentication
    authLogin: `/auth/azure/authenticate`,
    authInfo: `/auth/azure/auth-info`,
    authLogout: `/app-users/logout`,

    // Dossier APIs
    getCountryDetails: `/get_country_name`,
    getProductDetails: `/formulation_name_clean`,
    getRegiObjectiveDetails: `/registration_objective`,
    getBinderDetails: `/binder_id`,
    generateDossier: `/generate_dossier`,
    downloadDossier: `/download_dossier`,

    // Prompt Manager APIs
    getPromptManagerCountries: `/pm/countries`,
    getPromptManagerProperties: `/pm/properties`,
};

export default API_ENDPOINTS;
